import React from "react";

import Header from "components/Header";
import ZoningSummary from "components/guides/ZoningDetails/ZoningSummary";
import Field from "components/project_form/Field";
import HelpBar from "components/projects/HelpBar";
import { useAnswerContext } from "contexts/answerContext";
import { useGuide } from "queries/guides";
import { getAnswer } from "queries/projects";

import Step from "../requirement/Step";
import * as Layout from "./Layout";

const ZoningVerificationPage = () => {
  const { record: project } = useAnswerContext();

  const projectTypeAnswered = !!getAnswer(project, "project_type")?.use?.slug;
  const addressAnswered = !!getAnswer(project, "address")?.latitude;
  const { data: guide } = useGuide(project.guide_id);

  return (
    <Layout.Page name="zoning-check">
      <Header hideTitle />
      <Layout.Main>
        <Layout.Content>
          <Step header={guide?.header_title} instructions={guide?.message} />
          <Field fieldIdentifier="field:project_type" behaviorType="inline" />
          {projectTypeAnswered && (
            <div>
              <h3>Where would you like to check your zoning for?</h3>
              <Field fieldIdentifier="field:address" behaviorType="inline" />
            </div>
          )}
          {addressAnswered && <ZoningSummary />}
        </Layout.Content>
        <HelpBar />
      </Layout.Main>
    </Layout.Page>
  );
};

export default ZoningVerificationPage;
